import React, { useState, useEffect } from 'react';
import {Link, useNavigate} from 'react-router-dom';


const Inicio = () => {
  const [soporteDisponible, setSoporteDisponible] = useState(false);
  const [diaSemana, setDiaSemana] = useState(null); // Definir diaSemana como estado
  const token = localStorage.getItem("AuthToken");
  const logged = token ? true : false;
  
  const navigate = useNavigate();

    if (logged) {
      navigate('/servicios-y-clientes');
    } 

  useEffect(() => {
    const ahora = new Date();
    const diaSemanaActual = ahora.getDay(); // 0 (Domingo) a 6 (Sábado)
    const hora = ahora.getHours();
    
    // Verificar si es Lunes a Jueves entre las 8:00 am y las 16:00 pm
    const esLunesAJueves = diaSemanaActual >= 1 && diaSemanaActual <= 4;
    const esViernes = diaSemanaActual === 5;
    const esHoraHabil = hora >= 8 && ((esViernes && hora < 15) || (!esViernes && hora < 16));

    if ((esLunesAJueves || esViernes) && esHoraHabil) {
      setSoporteDisponible(true);
    } else {
      setSoporteDisponible(false);
    }

    // Establecer el valor de diaSemana
    setDiaSemana(diaSemanaActual);
  }, []);

  return (
    <main className='inicio'>
      <div className='site-width'>
        <div className="grid-inicio">
          <div className="texto-inicio">
            <h1>Plataforma de Gestión integrada con Holded</h1>
            <p>Gestiona acciones internas que holded no ofrece nativamente.</p>
            <Link to={'/iniciar-sesion'}><button className='boton'>Inicia sesión</button></Link>
          </div>
          <div className="visual-inicio">
            <img src="/images/blob.svg" alt="Blob" className='blob-uno' />
            <img src="/images/blob.svg" alt="Blob" className='blob-dos' />
            <div class="card-intro">
              <div class="card-frase">
                <div class="loader-frase">
                  <p>Todo en uno.</p>
                  <div class="words">
                    <span class="word">Datos financieros</span>
                    <span class="word">Notificaciones electrónicas</span>
                    <span class="word">Rendimiento</span>
                    <span class="word">Y mucho más</span>
                    <span class="word">Datos financieros</span>
                  </div>
                </div>
              </div>

                <div class="card_load_extreme_title"></div>
                <div class="card_load_extreme_descripion"></div>
            </div>            
          </div>
        </div>
      </div>
    </main>
  );
};

export default Inicio;
